<template>
  <div class="documents">
    <v-row justify="center" no-gutters>
        <v-col md="5">
            <intract-smart-list
              class="mt-2"
              paginated
              :endpoint="endpoints.documentsViewSet"
            >
            <template v-slot:list-item="{ item: documentInstance }">
                <v-list-item
                    @click="openDocumentInstance(documentInstance)"
                >
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                            documentInstance.template_document_type.document_name
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                            {{ moment(documentInstance.created).format("LLL") }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                  <v-list-item-icon class="align-center">
                    <v-btn
                      icon
                      color="primary"
                      class="non-focused"
                      v-if="documentsList.find(doc => doc.id === documentInstance.id && doc.progress == 100)"
                      @click="openFile(documentsList.find(doc => doc.id === documentInstance.id))"
                      ><v-icon>mdi-check</v-icon> Open</v-btn
                    >
                    <v-btn
                    @click="downloadDocumentInstance(documentInstance)"
                    color="primary"
                    class="non-focused"
                    icon
                    v-else
                  >
                    <v-icon v-if="!documentsList.find(doc => doc.id === documentInstance.id) || !documentsList.find(doc => doc.id === documentInstance.id).progress"
                      >mdi-download</v-icon
                    >
                    <span v-else>{{ documentsList.find(doc => doc.id === documentInstance.id).progress }}%</span>
                  </v-btn>
                  </v-list-item-icon>
                </v-list-item>

                <v-divider class="mx-4"></v-divider>
            </template>
          </intract-smart-list>
        </v-col>
    </v-row>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import endpoints from "@api/repository";
import IntractSmartList from "@components/generics/IntractSmartList";
import moment from "moment";
import Mixins from "@utils/mixins";

export default {
  name: "Documents",
  mixins: [Mixins.essentials, Mixins.downloadEssentials],
  components: {
    IntractSmartList,
  },
  data() {
    return {
        endpoints,
        moment,
        documentsList: [],
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    async downloadDocumentInstance(documentInstance) {
        const documentUrl = this.endpoints.documentsViewSet + documentInstance.id + "/view/?attachment=true";
        var document = {
            document: documentUrl,
            file_name: 'document_' + documentInstance.template_document_type.document_name + "_"+ documentInstance.id + '.pdf',
            id: documentInstance.id,
            progress: null,
        }
        this.documentsList.push(document);
        await this.downloadDocument(document, false);
    },

    dataURItoBlob(dataURI) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'application/pdf' });
        return blob;
    },
  },
};

</script>